import { NotFound } from "src/pages/not-found";

/**
 * Fallback route handler for unmatched paths.
 * All other routes have been migrated to jsonSlugRoutes.
 */
export const SlugRoutes = () => {
  return <NotFound />;
};
